import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useCompany, PageHeader, EmptyState, Money } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { fmtDate } from "@/lib/format";
import { Loader2 } from "lucide-react";

const METHOD = { cash: "Espèces", bank: "Banque", mobile_money: "Mobile Money" };
const PROVIDER = { orange_money: "Orange Money", moov_money: "Moov Money", wave_money: "Wave" };

export default function Payments() {
  const { companyId, cur } = useCompany();
  const [items, setItems] = useState(null);
  useEffect(() => { if (companyId) api.get("/payments", { params: { company_id: companyId } }).then(({ data }) => setItems(data.payments)); }, [companyId]);

  return (
    <div data-testid="payments-page">
      <PageHeader title="Paiements" subtitle="Historique des encaissements réconciliés." />
      <Card className="rounded-md border-border shadow-sm overflow-hidden">
        {items === null ? <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
          : items.length === 0 ? <EmptyState title="Aucun paiement" hint="Encaissez une facture pour voir les paiements ici." />
          : <Table>
              <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Client</TableHead><TableHead>Facture</TableHead><TableHead>Moyen</TableHead><TableHead className="text-right">Montant</TableHead></TableRow></TableHeader>
              <TableBody>{items.map((p) => (
                <TableRow key={p.id} data-testid={`payment-row-${p.id}`}>
                  <TableCell className="text-sm text-muted-foreground">{fmtDate(p.received_at)}</TableCell>
                  <TableCell className="font-medium">{p.customer_name}</TableCell>
                  <TableCell className="font-mono text-xs">{p.invoice_number}</TableCell>
                  <TableCell><Badge className="border-0 bg-accent text-primary">{p.provider ? PROVIDER[p.provider] : METHOD[p.method]}</Badge></TableCell>
                  <TableCell className="text-right text-emerald-600 font-semibold"><Money value={p.amount} cur={cur} /></TableCell>
                </TableRow>))}
              </TableBody>
            </Table>}
      </Card>
    </div>
  );
}
